module.exports = __webpack_public_path__ + "static/media/1.1b813327.jpeg";